import React from 'react';
import './style.scss';
import { toAbsoluteUrl } from '../../../../_metronic/helpers/AssetHelpers';

const LoadingSpinner = () => {
  return (
    <div className="overlay-custom">
      <div className="overlay-custom-img">
        <svg width="85" height="70" viewBox="0 0 85 70" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fillRule="evenodd" clipRule="evenodd" d="M42.2688 0L60.4016 30.1029H84.2726V31.6052H55.3602L46.2677 23.7162L29.1725 31.6322L35.0537 36.8407L45.7236 32.2574L68.4742 52.2763H84.2726V54.1633H74.8944L84.4351 70H42.2688H0.1028L7.32499 58.0111H0.000229465L0.033043 55.9121H31.3067L22.8569 47.6735L36.9034 42.1521L50.6234 55.6932H68.8076C60.932 48.7153 53.0546 41.7361 45.1791 34.7579L34.7256 39.0283L30.2611 35.684H0V33.3053H22.2064L42.2688 0ZM26.3425 48.298L36.4681 44.5489L48.7727 56.6307L38.9716 60.6928L26.3425 48.298Z" fill="#1B95D7"/>
        </svg>
      </div>
    </div>
  );
};

export default LoadingSpinner;
